import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'micro-ne-type-detail',
  templateUrl: './ne-type-detail.component.html'
})
export class NeTypeDetailComponent implements OnInit {
  @Input() neTypeId: any;
  @Output() persisted = new EventEmitter<any>();
  neType: any;
  private subscriptions = new Subscription();

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.neTypeId) {
      this.load(this.neTypeId);

    } else {
      this.subscriptions.add(this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      }));
    }
  }

  load(id: string): void {
    this.subscriptions.add(this.http.get(`${this.env.e.url}/domain/neTypes/${id}`).subscribe(data => {
      this.neType = data;
    }));
  }

  createNew(): void {
    this.neType = { name: '', description: 'None', active: 'N', companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const params = new HttpParams().set('companyId', this.neType.companyId || this.auth.getCompanyId());
    const isUpdate = !!this.neType.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/neTypes/${this.neType.id}`, this.neType, {params})
      : this.http.post(`${this.env.e.url}/domain/neTypes`, this.neType, {params});
    this.subscriptions.add(request.subscribe(data => {
      this.neType = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.neType.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    }));
  }

  delete(): void {
    this.subscriptions.add(this.http.delete(`${this.env.e.url}/domain/neTypes/${this.neType.id}`).subscribe(() => {
      this.persisted.emit({data: this.neType, action: 'deleted'});
      this.alertService.info(`Deleted ${this.neType.name}`);
      if (!this.neTypeId) { this.router.navigate(['/neTypes']); }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.neType.active = target.checked ? 'Y' : 'N';
  }
}
